import { Add_Blog, Get_All_Blogs, Get_Error, Get_one_Blog, Delete_Blog } from "../Types";

// dummyBlogs constant removed

const initialState = {
  Blog: {},
  loading: false,
  error: null,
};

const BlogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Add_Blog:
      return {
        ...state,
        Blog: action.payload,
        loading: false,
        error: null,
      };

    case Get_All_Blogs:
      return {
        ...state,
        Blog: action.payload,
        loading: false,
        error: null,
      };

    case Get_one_Blog:
      return {
        ...state,
        Blog: action.payload,
        loading: false,
        error: null,
      };

    case Delete_Blog:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case Get_Error:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default BlogsReducer;